<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('action.debtDeliveryVerify'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoInnerSerialNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.categoryId"
            :placeholder="$t('menu.categories')"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.ownerId"
            filterable
            clearable
            :placeholder="$t('text.owner')"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.shopId"
            :placeholder="$t('menu.shops')"
            filterable
            clearable
          >
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              type="primary"
              size="mini"
              :loading="batchDeliverVerifyDoing"
              @click="batchDeliverVerify"
              >{{ $t("action.debtDeliveryVerify") }}</el-button
            >
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="selectRecord"
        @checkbox-all="selectAllRecords"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :span-method="mergeMethod"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isBargain && !row.isLoadDF">
              <thumbnail :images="row.images"></thumbnail>
            </span>
            <div v-if="row.isBargain">
              <span class="float-left">
                <span class="blue mgr5" @click="showBargain(row)">{{
                  row.serialNo
                }}</span>
                <span class="font10 mgr5"
                  >{{ $t("bargain.productQty") }}:{{ row.productQty }}</span
                >
                <span
                  v-if="Permit.canActions('globalSalePrice')"
                  class="font10"
                >
                  <span class="mgr5">
                    {{ $t("bargain.amount") }}:
                    <currency :code="row.currency"></currency>
                    {{ row.amount }}
                  </span>
                  <span v-if="row.settleType == 'later'">{{
                    $t("settleTypes.later")
                  }}</span>

                  <span v-if="row.settleType == 'now'">
                    <el-popover placement="right" width="600" trigger="click">
                      <vxe-table :data="row.payments" size="small" border>
                        <vxe-table-column
                          field="total"
                          :title="$t('payment.total')"
                          min-width="100px"
                        >
                          <template v-slot="{ row }">
                            <currency :code="row.currency"></currency>
                            {{ row.total }}
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="payMethodName"
                          :title="$t('payment.payMethod')"
                          min-width="80px"
                        ></vxe-table-column>
                        <vxe-table-column
                          field="paidAt"
                          :title="$t('payment.paidAt')"
                          min-width="110px"
                        ></vxe-table-column>
                        <vxe-table-column
                          field="ownerName"
                          :title="$t('payment.ownerName')"
                          min-width="80px"
                        ></vxe-table-column>
                        <vxe-table-column
                          field="voucher"
                          :title="$t('payment.voucher')"
                          min-width="120px"
                        >
                          <template v-slot="{ row }">
                            <thumbnail-text :srcs="row.voucher" />
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="explain"
                          :title="$t('payment.explain')"
                          min-width="120px"
                        ></vxe-table-column>
                      </vxe-table>
                      <span slot="reference" class="popover-reference">
                        <span class="mgr5">
                          {{ $t("bargain.receive") }}:
                          <currency :code="row.currency"></currency>
                          {{ row.payAmount }}
                        </span>
                        <span v-if="row.ignoreAmount > 0" class="mgr5">
                          {{ $t("bargain.ignore") }}:
                          <currency :code="row.currency"></currency>
                          {{ row.ignoreAmount }}
                        </span>
                      </span>
                    </el-popover>

                    <span v-if="row.differAmount > 0" class="red mgr5">
                      {{ $t("bargain.differ") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.differAmount }}
                    </span>
                    <span v-if="row.differAmount == 0" class="green mgr5">{{
                      $t("bargain.settled")
                    }}</span>
                    <span v-if="row.differAmount < 0" class="orange">
                      {{ $t("bargain.leave") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.differAmount * -1 }}
                    </span>

                    <small v-if="row.deliveryAudit != null" class="green">
                      {{ $t("action.debtDeliveryVerify") }}:
                      {{ row.deliveryAudit.commentName }}
                      {{ row.deliveryAudit.commentAt }}
                    </small>
                  </span>
                </span>
              </span>
              <span class="float-right font10">
                {{ $t("menu.customers") }}:{{ row.customerName }}
                <!-- <span
                  v-if="row.replaceCustomerId != null && row.customer != null"
                  >{{ row.customer.name }}</span
                >
                <span v-if="row.replaceCustomerId == null">{{
                  row.customerName
                }}</span> -->
                <span v-if="row.customer != null && row.customer.type != null"
                  >({{ $t("customerTypes." + row.customer.type) }})</span
                >
                {{ $t("text.owner") }}:{{ row.ownerName }} {{ row.shopName }}
              </span>
            </div>
            <div v-if="row.isLoadDF" class="center">
              <i class="el-icon-loading" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red"
              >({{ $t("order.hurrySimple") }})</small
            >
            <span @click="showOrder(row)" class="font10">
              <s v-if="row.workflowState == 'canceled'" class="grey">{{
                row.serialNo
              }}</s>
              <span v-else class="blue">{{ row.serialNo }}</span>
            </span>
            <div class="font10">{{ row.innerSerialNo }}</div>
            <div>
              <state-label
                :state="row.workflowState"
                :permit="Permit.canActions('orderDealView')"
              >
                <span v-if="Permit.canActions('orderDealView')">{{
                  $t("orderStates." + row.workflowState)
                }}</span>
                <span v-else>{{
                  $t("orderStatesNoPermit." + row.workflowState)
                }}</span>
              </state-label>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >

            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
            <div class="orange font10">
              {{ $t("order.dealQuantity") }}: {{ row.dealQuantity
              }}{{ row.unit }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deliveredQuantity"
          :title="$t('order.deliveredQuantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <div class="font10">
              <el-popover
                placement="right"
                width="600"
                trigger="click"
                @show="getDeliveries(row)"
              >
                <vxe-table
                  :data="deliveries"
                  id="deliverInfosTable"
                  row-id="id"
                  ref="deliverInfosTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  auto-resize
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="deliverType"
                    :title="$t('delivery.deliveryMethode')"
                    min-width="80px"
                  >
                    <template v-slot="{ row }">
                      <span v-if="row.deliverType != null">{{
                        $t("deliverTypes." + row.deliverType)
                      }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="express"
                    :title="$t('delivery.express')"
                    min-width="80px"
                  />
                  <vxe-table-column
                    field="deliverMethodName"
                    :title="$t('delivery.channel')"
                    min-width="60px"
                  />
                  <vxe-table-column
                    field="tracking"
                    :title="$t('delivery.tracking')"
                    min-width="60px"
                  />
                  <vxe-table-column
                    field="attachment"
                    :title="$t('product.attachment')"
                    min-width="60px"
                  >
                    <template v-slot="{ row }">
                      <thumbnail-text :srcs="row.attachment" :text="'附件'" />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="deliverBy"
                    :title="$t('delivery.deliverBy')"
                    min-width="80px"
                  />
                  <vxe-table-column
                    field="deliverAt"
                    :title="$t('delivery.deliverAt')"
                    min-width="110px"
                  />
                </vxe-table>
                <span slot="reference" class="popover-reference">
                  {{ row.deliveredQuantity }}{{ row.unit }}
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="130"
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealtAt"
          :title="$t('order.dealtAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealRemark"
          :title="$t('order.dealRemark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.dealRemark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span> 条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ===== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="showBargainDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-bargain :id="currentRowBargainId" />
    </drawer>
    <drawer
      :title="$t('text.view', [$t('menu.orders')])"
      :visible.sync="showOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order :id="currentRowOrderId" />
    </drawer>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import ls from "store2";
import { table, page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";

import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import Thumbnail from "@/components/Thumbnail";
import ThumbnailText from "@/components/ThumbnailText";

//
import Bargain from "@/api/bargain.js";
import Order from "@/api/order.js";
import User from "@/api/user.js";
import Category from "@/api/category.js";
import Shop from "@/api/shop.js";
import Delivery from "@/api/delivery.js";
//
import ShowBargain from "./showBargain.vue";
import ShowOrder from "./showOrder.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Currency,
    RawHtmlLimitNumber,
    RawHtml,
    Thumbnail,
    ThumbnailText,
    ShowBargain,
    ShowOrder,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "bargains_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("action.verify"),
            items: [
              {
                label: this.$t("verifyInfos.agree"),
                key: "agree",
                condition: { deliveryVerify: "agree" },
              },
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { deliveryVerify: "no" },
              },
            ],
          },
          {
            label: this.$t("order.orderDeliverInfo"),
            items: [
              {
                label: this.$t("order.complete"),
                key: "yes",
                condition: { prepared: "yes" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        keyword: null,
        customerName: null,
        productNo: null,
        createAtStartAt: null,
        createAtEndAt: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        ownerId: null,
        shopId: null,
        categoryId: null,
        customerType: null,
        productBrand: null,
        color: null,
        size: null,
      },
      users: [],
      categories: [],
      shops: [],
      //
      currentRowIdx: null,
      currentRowBargainId: null,
      currentRowOrderId: null,
      showBargainDF: false,
      showOrderDF: false,

      deliveries: [],
      //
      batchDeliverVerifyDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        payInfo: "debt",
        settleType: "now",
      };
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.narrowsWorkflowStates();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Category.findByTenantId(),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, categories, shops) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    narrowsWorkflowStates() {
      const self = this;
      if (self.Permit.canActions("orderDealView")) {
        var states = Order.states_pre;
        if (self.Permit.canActionsConfigDealType("available")) {
          states = states.concat(Order.states_available);
        }
        if (self.Permit.canActionsConfigDealType("purchase")) {
          states = states.concat(Order.states_purchase);
        }
        if (self.Permit.canActionsConfigDealType("manufacture")) {
          states = states.concat(Order.states_manufacture);
        }
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: states.concat(Order.states_after).map((s) => {
              return {
                key: s,
                label: self.$t("orderStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },
        ]);
      } else {
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: Order.states_no_permint.map((s) => {
              return {
                key: s.key,
                label: self.$t("orderStates." + s.key),
                condition: { workflowStates: s.workflowStates },
              };
            }),
          },
        ]);
      }
      if (window.location.href.indexOf("unconfirms") != -1) {
        self.initFilter = "confirming";
      }
    },
    //
    batchDeliverVerify() {
      const self = this;
      if (self.selectedBargains().length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const datas = self.selectedBargains().map((b) => {
        return {
          entityId: b.id,
          comment: null,
        };
      });
      self.batchDeliverVerifyDoing = true;
      Bargain.batchDebtDeliverVerifyAgree(datas).then(function (res) {
        if (res.status == 200) {
          self.batchDeliverVerifyDoing = false;
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //=========
    showOrder(row) {
      this.currentRowOrderId = row.id;
      this.showOrderDF = true;
    },
    showBargain(row) {
      this.currentRowBargainId = row.id;
      this.showBargainDF = true;
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (row.isBargain && row.deliveryAudit == null) {
        return true;
      }
      return false;
    },

    //
    // dataProvider(params) {
    //   return Bargain.pendingDeliverSearch(params);
    // },
    // recordsDecorate(records) {
    //   this.records = this.buildTableData(records);
    //   this.mergeCells = this.buildMergeCells(records);
    // },

    dataProvider(params) {
      return Bargain.pendingDeliverSearchNoOrders(params);
    },
    recordsDecorate(records) {
      const self = this;
      for (const record of records) {
        Vue.set(record, "orders", []);
        Vue.set(record, "isLoadDF", true);
      }
      self.records = self.buildTableData(records, "first");
      self.mergeCells = self.buildMergeCells(records, "first");

      if (records.map((r) => r.id).length != 0) {
        Bargain.findWithOrdersByIdsForList(records.map((r) => r.id)).then(
          function (res) {
            if (res.status == 200) {
              for (const record of res.data) {
                Vue.set(record, "loadingDF", false);
              }
              let newBargain = JSON.parse(JSON.stringify(res.data));
              for (const record of records) {
                let index = newBargain.findIndex((d) => d.id == record.id);
                if (index != -1) {
                  record.orders = newBargain[index].orders;
                  newBargain.splice(index, 1);
                } else {
                  record.orders = [];
                }
              }
              self.records = self.buildTableData(records, "second");
              self.mergeCells = self.buildMergeCells(records, "second");
            } else {
              self.sysError();
            }
          }
        );
      }
    },

    buildTableData(records, type) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          uuid: record.uuid,
          serialNo: record.serialNo,
          shopId: record.shopId,
          shopName: record.shopName,
          settleType: record.settleType,
          amount: record.amount,
          currency: record.currency,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          customerType: record.customerType,
          customerSource: record.customerSource,
          customerEmail: record.customerEmail,
          deliveryRemark: record.deliveryRemark,
          groupJson: record.groupJson,
          remark: record.remark,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          createAt: record.createAt,
          plateform: record.plateform,
          plateformBargainId: record.plateformBargainId,
          cnyAmount: record.cnyAmount,
          replaceCustomerId: record.replaceCustomerId,
          lastDealtAt: record.lastDealtAt,
          customer: record.customer,
          productAmount: record.productAmount,
          // currentMonthAmount: record.currentMonthAmount,
          plateformStoreId: record.plateformStoreId,
          financeDeliveryAt: record.financeDeliveryAt,
          deliveryAudit: record.deliveryAudit,
          financeAudit: record.financeAudit,
          payAmount: record.payAmount,
          productQty: record.productQty,
          differAmount: record.differAmount,
          ignoreAmount: record.ignoreAmount,
          orders: record.orders,
          payments: record.payments,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        // record.orders.forEach((order) => {
        //   rs.push(order);
        // });
        if (record.orders && record.orders.length != 0) {
          for (const order of record.orders) {
            Vue.set(order, "_bargain", bOrder);
            rs.push(order);
          }
        } else {
          if (type == "first") {
            rs.push({ isLoadDF: true, orders: [] });
          }
        }
      });
      return rs;
    },
    buildMergeCells(bargains, type) {
      let mcs = [];
      if (type == "first") {
        for (let i = 0, rowIdx = 0; i < this.pager.pageSize * 2; i++) {
          mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 9 });
          rowIdx = rowIdx + 1;
        }
        return mcs;
      } else {
        for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
          mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 9 });
          rowIdx = rowIdx + bargains[i].orders.length + 1;
        }
        return mcs;
      }
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isBargain
        ? "light-blue-bg"
        : this.rowBgColor({ row: row, rowIndex: rowIndex });
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (!noColorWorkflowStates.includes(row.workflowState)) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (!noColorWorkflowStates.includes(row.workflowState)) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
    selectedBargains() {
      return this.$refs.recordsTable
        .getCheckboxRecords()
        .filter((r) => r.isBargain);
    },
    selectedOrders() {
      return this.$refs.recordsTable
        .getCheckboxRecords()
        .filter((r) => !r.isBargain);
    },
    selectRecord({ rowIndex, selection, checked, row, data }) {
      if (row.isBargain) {
        let orders = data.filter((r) => r.bargainId == row.id);
        this.$refs.recordsTable.setCheckboxRow(orders, checked);
      }
      this.setSelectedQty();
    },
    selectAllRecords() {
      this.setSelectedQty();
    },
  },
};
</script>
<style scoped>
.group {
  float: left;
  margin-left: 10px;
  border: 1px solid rgba(64, 158, 255, 0.2);
  color: #409eff;
  background: rgba(64, 158, 255, 0.1);
  padding: 0px 4px;
  border-radius: 3px;
  font-size: 12px;
}
</style>